<template>
  <!--  :key trick to force remount of the component when image is removed -->
  <AvatarRoot :key="src ?? ''" class="relative inline-flex shrink-0 select-none rounded-full" :class="AvatarIconSize[size]">
    <AvatarImage v-if="src" :src="src" class="h-full w-full rounded-full object-cover" />
    <AvatarFallback
      class="flex h-full w-full items-center justify-center overflow-hidden rounded-full"
      :class="{ 'bg-gray-light text-neutral': !$slots.default }"
    >
      <slot>
        <!-- hide default fallback content when overlay is used; overlay div covers image but not fallback content -->
        <template v-if="!$slots.overlay">
          <span v-if="initials">{{ initials }}</span>
          <SvgIcon v-else icon="User" />
        </template>
      </slot>
    </AvatarFallback>
    <div v-if="$slots.overlay" class="absolute inset-0 flex items-center justify-center rounded-full">
      <slot name="overlay" />
    </div>
    <div v-if="badge && statusVisible" class="absolute flex h-4 w-4 items-center justify-center" :class="badge.class">
      <SvgIcon v-if="badge.icon" :icon="badge.icon" size="sm" class="shrink-0" />
    </div>
  </AvatarRoot>
</template>

<script setup lang="ts">
import { type BadgeConfig, AvatarIconSize, type AvatarSize } from '@/utils/avatarUtils';
import SvgIcon from '@/components/SvgIcon.vue';
import { AvatarFallback, AvatarImage, AvatarRoot } from 'reka-ui';

const { statusVisible = true, size = 'md' } = defineProps<{
  src?: string | null;
  initials?: string;
  badge?: BadgeConfig;
  statusVisible?: boolean;
  size?: AvatarSize;
}>();
</script>
